import React, { useState } from 'react';
import {
  Paper,
  Typography,
  IconButton,
  Collapse,
  Box,
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

export default function ModelReview({ data }) {
  const [expanded, setExpanded] = useState(true);
  const models = useSelector((state) => state.models || []);

  if (!data) {
    return null;
  }

  const { source_type, source_uri, checkpoints } = data;
  let model;
  if (source_type === THIRD_PARTY_TYPES.TRAINML.value) {
    model = models.find((model) => model.model_uuid === source_uri);
  }

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          p: 1,
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <IconButton size='small'>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        <Typography variant='h6'>Model</Typography>
      </Box>
      <Collapse in={expanded}>
        <Paper sx={{ p: 2, mb: 2 }}>
          {source_uri ? (
            <Typography>
              {source_type !== THIRD_PARTY_TYPES.TRAINML.value ? (
                <>
                  Load <b>{source_uri}</b> from <b>{source_type}</b> into{' '}
                </>
              ) : (
                <>
                  Load Model: <b>{model?.name}</b> into{' '}
                </>
              )}
              <span
                style={{
                  fontFamily: '"Courier New", Courier, monospace',
                }}
              >
                /opt/ml/models
              </span>
            </Typography>
          ) : null}

          {checkpoints && checkpoints.length ? (
            <Box sx={{ mt: 2 }}>
              {checkpoints.length === 1 ? (
                <Typography>
                  Load checkpoint <b>{checkpoints[0].name}</b> into{' '}
                  <span
                    style={{
                      fontFamily: '"Courier New", Courier, monospace',
                    }}
                  >
                    /opt/ml/checkpoint
                  </span>
                </Typography>
              ) : (
                checkpoints.map((checkpoint) => (
                  <Typography key={checkpoint.checkpoint_uuid} sx={{ mb: 1 }}>
                    Load checkpoint <b>{checkpoint.name}</b> into{' '}
                    <span
                      style={{
                        fontFamily: '"Courier New", Courier, monospace',
                      }}
                    >
                      /opt/ml/checkpoint/
                      {checkpoint.name.toLowerCase().replaceAll(' ', '_')}
                    </span>
                  </Typography>
                ))
              )}
            </Box>
          ) : null}
        </Paper>
      </Collapse>
    </Box>
  );
}

